import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { HttpService } from './http.service';

export interface PerformedOnUser {
  id: number;
  name: string;
  email: string;
  first_name: string;
  last_name: string;
  phone_number?: string;
  avatar?: string;
  status?: string;
  [key: string]: any; // Allow additional properties from the API
}

export interface ActivityLogProperties {
  email?: string;
  ip?: string;
  user_agent?: string;
  [key: string]: any;
}

export interface ActivityLog {
  event: string;
  causer_name: string;
  ip_address: string;
  performed_at: string;
  performed_on: PerformedOnUser;
  description: string;
  log_name: string;
  properties: ActivityLogProperties;
}

export interface PaginationMeta {
  current_page: number;
  from: number;
  last_page: number;
  path: string;
  per_page: number;
  to: number;
  total: number;
  links?: Array<{
    url: string | null;
    label: string;
    active: boolean;
  }>;
}

export interface ActivityLogsResponse extends ApiResponse {
  data: ActivityLog[];
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: PaginationMeta;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class LogsApiService {
  constructor(private apiService: HttpService) {}

  /**
   * Fetches user agency activity logs for a given user/agency ID.
   * Works for Brokers, Agents, and Dealers.
   * @param id - The user or agency ID
   * @param params - Optional query parameters (e.g., page, per_page)
   */
  getUserAgencyActivityLogs(
    id: number | string,
    params: any = {}
  ): Observable<ActivityLogsResponse> {
    return this.apiService.getReq(`/user-agency-activity-logs/${id}`, {
      params,
    });
  }
}
